import { createSlice } from '@reduxjs/toolkit'

const loginInitialState = {
  phoneNumber: '',
  hasOTPSent: false,
  hasOTPResent: false,
  loginModalIsOpen: false,
  isUserLoggedIn: false,
  activeStep: 1,
}

const loginSlice = createSlice({
  name: 'loginDataReducer',
  initialState: loginInitialState,
  reducers: {
    updateLoginData: (state, action) => {
      state.phoneNumber = action.payload.phoneNumber
      state.hasOTPSent = action.payload.hasOTPSent
      state.hasOTPResent = action.payload.hasOTPResent
      state.loginModalIsOpen = action.payload.loginModalIsOpen
      state.isUserLoggedIn = action.payload.isUserLoggedIn
      state.activeStep = action.payload.activeStep
    },
    resetLoginData: () => {
      return loginInitialState
    },
  },
})
export const { updateLoginData, resetLoginData } = loginSlice.actions
export default loginSlice.reducer
